module.exports = __webpack_public_path__ + "assets/img/img15.cd3ae656.png";